import { validatesArrayHasValue } from "utils/custom-functions";

export const disableButtonAcceptSuggestions = (_selecteds, _sendingSuggestions) => (
  !(validatesArrayHasValue(_selecteds) && _selecteds.find(x => x.SuggestionStatus < 5) && !_sendingSuggestions)
)

export const getSuggestionsForAcceptance = (_selecteds) => {
  const _selectedSuggestions = _selecteds.filter(x => x.SuggestionStatus < 5);

  return _selectedSuggestions.map(item => ({ Id: item.Id, Over: isInOver(item.StockUnitPriority), LabeledFamilYCenterId: item.LabeledFamilYCenterId, ExternalSuggestion: item.ExternalSuggestion }));
}

export const getSuggestionsForAcceptanceInOver = (_selecteds) => {
  const _selectedSuggestions = getSuggestionsForAcceptance(_selecteds);

  return _selectedSuggestions.filter(x => x.Over);
}

export const isInOver = (_stockUnitPriority) => (_stockUnitPriority == 1);

export const getExternalSuggestionRequest = (_suggestion, _userId, _justificationForOver) => {
  const _body = {
    UserId: _userId,
    IdSuggestion: [_suggestion.Id],
    LabeledFamilyCenterId: _suggestion.LabeledFamilYCenterId,
    OverOrderOrMaximumStock: _suggestion.Over,
    JustificationTypeOverOrder: _suggestion.Over ? _justificationForOver : null
  }

  return {
    API: `suggestions/external-data:accept`,
    method: 'post',
    body: _body,
    errorId: _suggestion.Id
  }
}

const getAcceptanceGroupKey = (suggestion, justificationForOver) =>
  `${suggestion.LabeledFamilYCenterId}|${suggestion.Over}|${suggestion.Over ? justificationForOver : ''}`;

export const getSuggestionAcceptanceRequests = (
  selectedSuggestions,
  userId,
  justificationForOver,
  stockReturn = null
) => {
  const groups = new Map();

  selectedSuggestions.forEach((suggestion) => {
    if (suggestion.ExternalSuggestion) return;
    const key = getAcceptanceGroupKey(suggestion, justificationForOver);
    const group = groups.get(key) || {
      labeledFamilyCenterId: suggestion.LabeledFamilYCenterId,
      over: suggestion.Over,
      suggestions: [],
    };
    group.suggestions.push(suggestion);
    groups.set(key, group);
  });

  // A single backend request has one LFC and one over/justification setting.
  // Attach each LFC's Stock Return items to one common batch (or its own batch).
  const requests = [...groups.values()].map((group) => ({ ...group, stockReturnItems: group.stockReturnItems || [] }));
  const stockReturnByLfc = (stockReturn?.items || []).reduce((byLfc, item) => {
    const key = String(item.labeledFamilyCenterId);
    byLfc.set(key, [...(byLfc.get(key) || []), item]);
    return byLfc;
  }, new Map());
  stockReturnByLfc.forEach((items, lfcKey) => {
    let request = requests.find((candidate) => String(candidate.labeledFamilyCenterId) === lfcKey);
    if (!request) {
      request = {
        labeledFamilyCenterId: items[0].labeledFamilyCenterId,
        over: false,
        suggestions: [],
        stockReturnItems: [],
      };
      requests.push(request);
    }
    request.stockReturnItems = items;
  });

  return requests.map((group) => {
    const ids = group.suggestions.map((item) => item.Id);
    const body = {
      UserId: userId,
      Suggestions: ids,
      LabeledFamilyCenterId: group.labeledFamilyCenterId,
      OrderInOverOrMaxStock: group.over,
      OrderInOverJustificationType: group.over ? justificationForOver : null,
      ...(group.stockReturnItems.length ? {
        StockReturn: {
          Items: group.stockReturnItems.map((item) => ({
            SuggestionId: item.suggestionId,
            POReference: item.poReference,
          })),
          Notification: stockReturn?.notification,
        },
      } : {}),
    };
    return {
      API: 'suggestions:accept',
      method: 'post',
      body,
      suggestionIds: [...ids, ...group.stockReturnItems.map((item) => item.suggestionId)],
    };
  });
};

// Kept for callers/tests that still need the legacy one-suggestion request shape.
export const getSuggestionRequest = (suggestion, userId, justificationForOver) => ({
  API: 'suggestions:accept',
  method: 'post',
  body: {
    UserId: userId,
    Suggestions: [suggestion.Id],
    LabeledFamilyCenterId: suggestion.LabeledFamilYCenterId,
    OrderInOverOrMaxStock: suggestion.Over,
    OrderInOverJustificationType: suggestion.Over ? justificationForOver : null,
  },
  errorId: suggestion.Id,
});
